import { create } from "zustand"

const useAwaitingDocWarehouse = create((set) => ({
  awaitingDocWarehouseOrders: [],
  awaitingDocWarehouseOrdersCount: 0,
  loading: true,
  setAwaitingDocWarehouseOrders: (orders) =>
    set({
      awaitingDocWarehouseOrders: orders,
      awaitingDocWarehouseOrdersCount: orders.length,
      loading: false,
    }),
  setAwaitingOrdersLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useAwaitingDocWarehouse
